import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { LivestreamService } from 'src/app/Core/services/livestream.service';
import { MovieService } from 'src/app/Core/services/movie.service';
import { SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';
import { Constant } from 'src/app/Core/services/data';
import { Subject } from 'rxjs';
import { Moviesdb } from 'src/app/Core/services/dexiedb/moviedb.service';

@Component({
  selector: 'app-dbloading-modal',
  templateUrl: './dbloading-modal.component.html',
  styleUrls: ['./dbloading-modal.component.css']
})
export class LoadingDbModalComponent implements OnInit {
  playlistItem: any;
  onClose: Subject<string> = new Subject();
  isLoadingdb:boolean = true;
  loadingItems = [
    { label: 'Live TV', loaded: false, progress: 0 },
    { label: 'Movies', loaded: false, progress: 0 },
    { label: 'Series', loaded: false, progress: 0 }
  ];
    boys = [{ name: 'manish' }];

  overallProgress = 0;
  currentLabel = '';

  constructor(
    public bsRef: BsModalRef,
    private router: Router,
    private livetvService: LivestreamService,
    private moviesService: MovieService,
    private seriesService: SeriesService,
    private utilService: UtilService
  ) {}

  async ngOnInit() {
        this.onClose.next('yes');
        localStorage.setItem('progressComplete','true')
        this.isLoadingdb = false;

    try {
      const item = this.playlistItem;
      this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
      this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
      this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
      this.utilService.saveValueStorage(Constant.FULLURL_KEY, item.dns);

      const total = this.loadingItems.length;
      let completed = 0;
      this.currentLabel = 'Loading Live TV categories...';
      await this.livetvService.loadLivetvCategories();
      this.currentLabel = 'Loading Live TV streams...';
      await this.livetvService.loadLivetv();
      this.markLoaded(0, ++completed, total);

      this.currentLabel = 'Loading Movie categories...';
      await this.moviesService.loadCategories();
      this.currentLabel = 'Loading Movies...';
      await this.moviesService.loadMovies();
      this.markLoaded(1, ++completed, total);

      this.currentLabel = 'Loading Series categories...';
      await this.seriesService.loadCategories();
      this.currentLabel = 'Loading Series...';
      await this.seriesService.loadSeries();
      this.markLoaded(2, ++completed, total);

      this.currentLabel = 'All content loaded!';
      setTimeout(() => {
        this.onClose.next('yes');
        this.bsRef.hide();
        this.router.navigate(['/home']);
      }, 1000);
    } catch (err) {
      console.error('Error:', err);
      this.onClose.next('no');
      this.bsRef.hide();
    }
    finally{
       localStorage.setItem('progressComplete','true')
      this.isLoadingdb = false;
    }
  }


  markLoaded(index: number, completed: number, total: number) {
    this.loadingItems[index].loaded = true;
    this.loadingItems[index].progress = 100;
    this.overallProgress = Math.round((completed / total) * 100);
    console.log(this.loadingItems);
    
  }
}
